import { create } from 'zustand';

interface DuplicateStore {
  pendingAssetIds: Array<string>;
  addPendingDuplicate: (id: string) => void;
  removePendingDuplicate: (id: string) => void;
}

export const useDuplicateStore = create<DuplicateStore>((set) => ({
  pendingAssetIds: [],
  addPendingDuplicate: (id) =>
    set((prev) => (prev.pendingAssetIds.includes(id) ? prev : { pendingAssetIds: [...prev.pendingAssetIds, id] })),
  removePendingDuplicate: (id) =>
    set((prev) => ({ pendingAssetIds: prev.pendingAssetIds.filter((pendingId) => pendingId !== id) })),
}));
